import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { OsobaZanimanje } from './osoba-zanimanje';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-osoba-zanimanje-update',
  templateUrl: './osoba-zanimanje-update.component.html'
})
export class OsobaZanimanjeUpdateComponent
extends BaseUpdateComponent<OsobaZanimanje>
 implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  
  ) { 
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    // this.addValidatorToFc("Broj", Validators.required, 'required', 'OSOBATELEFON.BROJ.VALIDATION.REQUIRED');
    // this.addValidatorToFc("Broj", Validators.maxLength(20), 'maxlength', 'OSOBATELEFON.BROJ.VALIDATION.MAXLENGTH');
  }

}
